// @services/globalToastBus.js

// import mitt
import mitt from 'mitt';

// global toast bus
const ToastBus = mitt();

// export the bus
export default ToastBus;